import { useEffect, useRef } from "react";

// Calls `callback` every `intervalMs` while the browser tab is visible.
// Keeps the latest callback in a ref so the timer isn't reset on every render.
export function usePolling(callback, intervalMs = 15000, enabled = true) {
  const cbRef = useRef(callback);
  useEffect(() => {
    cbRef.current = callback;
  }, [callback]);

  useEffect(() => {
    if (!enabled) return undefined;
    const id = setInterval(() => {
      if (document.visibilityState === "visible") {
        cbRef.current?.();
      }
    }, intervalMs);
    return () => clearInterval(id);
  }, [intervalMs, enabled]);
}
